export default __webpack_public_path__ + "static/media/Confirm.f37f7d60.svg";